module.exports = __webpack_public_path__ + "static/img/m_banner3.75512f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/m_banner3.png
// module id = Zd7g
// module chunks = 0